import TipoAcao from '../../spa/tipo-acao/TipoAcao';

export default {
  path: 'tipo-acao',
  name: 'tipo-acao',
  component: TipoAcao,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/tipo-acao.js